export interface IMonthValue {
  year: number;
  month: number;
}

export const getMonthValue = (date: Date) => {
  const month: IMonthValue = {
    month: date.getMonth(),
    year: date.getFullYear(),
  }
  return month;
}

export const getEndOfYearMonthValue = (date: IMonthValue) => {
  const month: IMonthValue = {
    month: 11,
    year: date.year,
  }
  return month;
}

export const getEndOfQMonthValue = (date: IMonthValue) => {
  const month: IMonthValue = {
    month: date.month+2,
    year: date.year,
  }
  return month;
}

export const getPreviousMonth = () => {
  const prev = new Date();
  prev.setMonth(prev.getMonth() - 1);
  const month: IMonthValue = {
    month: prev.getMonth(),
    year: prev.getFullYear()
  }
  return month;
}

export const formatQValue = (q: IMonthValue) => {
  let qval = 'Q' + (getQ(q.month)+1) + ", " + q.year;
  return qval;
}

export const getQ = (month: number) => {
  if(month >= 3 && month <= 5) return 1;
  if(month >= 6 && month <= 8) return 2;
  if(month >= 9 && month <= 11) return 3;
  return 0;
}

export const getQMonth = (q: number) => {
  if(q === 1) return 3;
  if(q === 2) return 6;
  if(q === 3) return 9;
  return 0;
}

export const getQStart = (m: IMonthValue) => {
  let month: IMonthValue = {
    month: getQMonth(getQ(m.month)),
    year: m.year
  }
  return month;
}

export const localHour = (hour: number) => {
  let now = new Date();
  if (hour)
    now.setUTCHours(hour);
  return now.getHours();
}

export const utcHour = (hour: string) => {
  let now = new Date();
  now.setHours(parseInt(hour));
  return now.getUTCHours();
}

export const formatYearValue = (year: number) => {
  const date = new Date();
  date.setFullYear(year);
  return date.getFullYear();
}

export const formatDateYYYYMM = (date: IMonthValue) => {
  const month = date.month + 1;
  const monthStr = month < 10 ? '0' + month : month;
  const value = `${date.year}-${monthStr}`;
  return value;
}

export const formatDateYYYYMMDD = (date: IMonthValue, end: boolean = false) => {
  const month = date.month + 1;
  const monthStr = month < 10 ? '0' + month : month;
  const day = end ? new Date(date.year, month, 0).getDate() : 1;
  const dayStr = day < 10 ? '0' + day : day;
  const value = `${date.year}-${monthStr}-${dayStr}`;
  return value;
}

export function formatDateMMYYYY(period: IMonthValue) {
  const date = getPeriodDate(period);
  const month = date.getMonth() + 1;
  return `${month < 10 ? '0' + month : month}-${date.getFullYear()}`;
}

export const formatPeriod = (start: string, end: string, intl: any) => {
  let dStart = new Date(start);
  let dEnd = new Date(end);
  let value = (intl.formatDate(dStart, { month: 'short', year: 'numeric' })) + " - " + 
              (intl.formatDate(dEnd, { month: 'short', year: 'numeric' }));
  if(dStart.getFullYear() === dEnd.getFullYear()) { // Same year
    value = (intl.formatDate(dStart, { month: 'short' })) + "-" + 
            (intl.formatDate(dEnd, { month: 'short', year: 'numeric' }));
    if(dStart.getMonth() === dEnd.getMonth()) { // Month
      value = intl.formatDate(dStart, { month: 'short', year: 'numeric' });
    }
    if(dStart.getMonth() === 0 && dEnd.getMonth() === 11) { // Year
      value = "" + dStart.getFullYear();
    }
    if(getQ(dStart.getMonth()) === getQ(dEnd.getMonth()) && dEnd.getMonth()-dStart.getMonth() === 2) { // Quarter
      value = "Q" + (getQ(dStart.getMonth())+1) + " " + dStart.getFullYear();
    }
  }
  return value;
}

export const getReportTypeString = (start: string, end: string, auto: boolean) => {
  let dStart = new Date(start);
  let dEnd = new Date(end);
  let value = 'MANUAL';
  if(dStart.getFullYear() === dEnd.getFullYear()) { // Same year
    if(auto && dStart.getMonth() === dEnd.getMonth()) { // Month
      value = 'MONTHLY';
    }
    if(dStart.getMonth() === 0 && dEnd.getMonth() === 11) { // Year
      value = 'YEARLY';
    }
    if(getQ(dStart.getMonth()) === getQ(dEnd.getMonth()) && dEnd.getMonth()-dStart.getMonth() === 2) { // Quarter
      value = 'QUARTER';
    }
  }
  return value;
}

export const formatDateRange = (startDate: IMonthValue, endDate: IMonthValue) => {
  const start = startDate.month + 1;
  const startStr = start < 10 ? '0' + start : start;
  const end = endDate.month + 1;
  const endStr = end < 10 ? '0' + end : end;
  return `${startStr}-${startDate.year}+${endStr}-${endDate.year}`;
}

export const getPeriodDate = (period: IMonthValue) => {
  return new Date(period.year, period.month);
}

export const getCurrentYear = () => {
  const date = new Date();
  return date.getFullYear().toString();
}